import { Pledge, PledgeCampaign, GivingPerson } from "../types"
import { Fund } from "source/giving/donate/form/types"
import { Heading, Badge } from "@planningcenter/doxy-web"
import { formattedCents } from "source/giving/utils/money"
import { css } from "@emotion/react"
import PledgeProgressBar from "./PledgeProgressBar"
import { date } from "@churchcenter/datetime-fmt"

export default function PledgeDetails({
  jointGiver,
  pledge,
  pledgeCampaign,
  fund,
}: {
  jointGiver: GivingPerson | null
  pledge: Pledge
  pledgeCampaign: PledgeCampaign
  fund: Fund
}) {
  const isConcluded = pledgeCampaign.ends_at
    ? new Date(pledgeCampaign.ends_at) < new Date()
    : false

  const campaignStartsAtDate = (() => {
    const startsAtDate = new Date(pledgeCampaign.starts_at)
    const isCurrentYear =
      startsAtDate.getFullYear() === new Date().getFullYear()
    return date(pledgeCampaign.starts_at, {
      style: "standard",
      year: !isCurrentYear,
    })
  })()

  const campaignEndsAtDate = (() => {
    const endsAtDate = new Date(pledgeCampaign.ends_at)
    const isCurrentYear = endsAtDate.getFullYear() === new Date().getFullYear()
    return date(pledgeCampaign.ends_at, {
      style: "standard",
      year: !isCurrentYear,
    })
  })()

  return (
    <div className="d-f fd-c g-2">
      <div className="d-f fd-c g-2 action-drawer">
        <div className="d-f fd-c g-2">
          <div>
            <div className="d-f jc-sb ai-c">
              <Heading
                level={3}
                size={4}
                text={formattedCents(pledge.joint_amount_cents, {
                  noCentsIfWhole: true,
                })}
                color="tint1"
              />
              <Badge text={fund?.name || "Fund"} />
            </div>
            <div className="fs-13 fw-600 c-tint2">
              {`To ${pledgeCampaign.name || "Pledge Campaign"}`.toUpperCase()}
            </div>
          </div>
          <PledgeProgressBar
            jointGiver={jointGiver}
            pledge={pledge}
            isConcluded={isConcluded}
          />
          <div
            className="d-f fd-c g-1 p-1 br-8p"
            css={css`
              background-color: var(--color-tint6);
            `}
          >
            <dl>
              {pledgeCampaign.show_goal_in_church_center_app && (
                <div className="d-f jc-sb">
                  <dt className="fs-13 fw-500 c-tint1">Campaign progress</dt>
                  <dd className="fs-5 ws-nw c-tint1">
                    {formattedCents(pledgeCampaign.received_total_cents || 0, {
                      noCentsIfWhole: true,
                    })}{" "}
                    of{" "}
                    {formattedCents(pledgeCampaign.goal_cents || 0, {
                      noCentsIfWhole: true,
                    })}{" "}
                    raised ({pledgeCampaign.received_of_goal_percent || "0%"})
                  </dd>
                </div>
              )}
              <div className="d-f jc-sb">
                <dt className="fs-13 fw-500 c-tint1">Donation period</dt>
                <dd className="fs-5 ws-nw c-tint1">
                  {campaignStartsAtDate} - {campaignEndsAtDate}
                </dd>
              </div>
            </dl>{" "}
          </div>
        </div>
      </div>
    </div>
  )
}
